import React, { useState } from 'react'
import ModalTest from '../../../BaseModal'
import * as S from '../../../styles/modal-style'
import axios from '../../../../config/axios'

interface SplitOPModalProps {
  setModalActive: React.Dispatch<React.SetStateAction<number | null>>
  id: number
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>
}

const SplitOPModal = ({setModalActive, id, setRefresh}: SplitOPModalProps) => {
  const [splitAmount, setSplitAmount] = useState<number>(2)
  
  const handleSplitOP = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/service/split`, {
        divideInto: splitAmount,
        opId: id
      })
      if(response.data) {
        setModalActive(null)
        setRefresh(prev => !prev)
      }
    } catch (error) {
      console.log(error)
    }
  }
  
  return (
    <ModalTest>
      <S.ContainerOfModal width='30rem'>
        <h2>Dividir esta OP em:</h2>
        <p>Informe quantas OPs serão criadas a partir desta.</p>
        <p
          style={{
            fontSize: '12px',
            color: '#666',
            marginTop: '1rem'
          }}
        >Recomendamos que as OPs sejam separadas por processos diferentes.</p>
        <S.Input type="number" value={splitAmount} onChange={(e) => setSplitAmount(Number(e.target.value))} placeholder='min 2' min={2} style={{
          marginTop: '.5rem'
        }} />
        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'flex-end',
          marginTop: '2rem'
        }}>
          <button
            onClick={() => setModalActive(null)}
            style={{
              padding: '0.5rem 1rem',
              border: '1px solid #ddd',
              background: 'transparent',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >Cancelar</button>
          <button
            onClick={handleSplitOP}
            style={{
              padding: '0.5rem 1rem', 
              border: 'none',
              background: '#0090D3',
              color: 'white',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >Dividir</button>
        </div>
      </S.ContainerOfModal>
    </ModalTest>
  )
}

export default SplitOPModal